var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "rich-input",
    staticClass: "rich-input",
    class: _vm.globalTabClasses
  }, [_vm.label ? _c('div', {
    staticClass: "rich-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "text-editor",
    class: {
      'single-line': this.mode == 'input' || this.mode == 'url'
    }
  }, [_vm.mode == 'textarea' ? _c('editor-menu-bubble', {
    staticClass: "menububble",
    attrs: {
      "editor": _vm.editor
    },
    on: {
      "hide": _vm.hideLinkMenu
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var commands = _ref.commands,
          isActive = _ref.isActive,
          getMarkAttrs = _ref.getMarkAttrs,
          menu = _ref.menu;
        return [_c('div', {
          staticClass: "menububble",
          class: {
            'is-active': menu.isActive
          },
          style: "left: ".concat(menu.left, "px; bottom: ").concat(menu.bottom, "px;")
        }, [_vm.linkMenuIsActive ? _c('form', {
          staticClass: "menububble__form"
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.linkUrl,
            expression: "linkUrl"
          }],
          ref: "linkInput",
          staticClass: "menububble__input",
          attrs: {
            "type": "text",
            "placeholder": "https://"
          },
          domProps: {
            "value": _vm.linkUrl
          },
          on: {
            "keydown": [function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.preventDefault();
              return _vm.setLinkUrl(commands.link);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
              return _vm.hideLinkMenu.apply(null, arguments);
            }],
            "click": function click($event) {
              $event.stopPropagation();
            },
            "input": [function ($event) {
              if ($event.target.composing) return;
              _vm.linkUrl = $event.target.value;
            }, function ($event) {
              _vm.linkError = '';
            }]
          }
        }), _c('button', {
          staticClass: "menububble__button ml-2",
          attrs: {
            "type": "button",
            "disabled": !_vm.linkUrl
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.setLinkUrl(commands.link);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-check")])], 1), _c('button', {
          staticClass: "menububble__button",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.removeLink(commands.link);
            }
          }
        }, [_c('v-icon', [_vm._v("$remove")])], 1)]), _vm.linkError ? _c('div', {
          staticClass: "menububble__error"
        }, [_vm._v(_vm._s(_vm.linkError))]) : _vm._e()]) : [_c('button', {
          staticClass: "menububble__button",
          class: {
            'is-active': isActive.bold()
          },
          on: {
            "click": commands.bold
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-format-bold")])], 1), _c('button', {
          staticClass: "menububble__button",
          class: {
            'is-active': isActive.italic()
          },
          on: {
            "click": commands.italic
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-format-italic")])], 1), _c('button', {
          staticClass: "menububble__button",
          class: {
            'is-active': isActive.underline()
          },
          on: {
            "click": commands.underline
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-format-underline")])], 1), _c('button', {
          staticClass: "menububble__button",
          class: {
            'is-active': isActive.link()
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              _vm.showLinkMenu(getMarkAttrs('link'));
            }
          }
        }, [_c('span', {
          staticClass: "text-no-wrap"
        }, [_vm._v(_vm._s(isActive.link() ? _vm.$t('update_link') : ''))]), !isActive.link() ? _c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("mdi-link")]) : _vm._e()], 1)]], 2)];
      }
    }], null, false, 456040633)
  }) : _vm._e(), _c('editor-content', {
    staticClass: "editor__content",
    class: {
      'disabled': _vm.disableInput
    },
    attrs: {
      "editor": _vm.editor
    }
  })], 1), _c('div', {
    staticClass: "error-ctn"
  }, _vm._l(_vm.errorMessages, function (msg, index) {
    return _c('div', {
      key: "error-msg-".concat(index)
    }, [_vm._v(_vm._s(msg))]);
  }), 0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSuggestions,
      expression: "showSuggestions"
    }],
    ref: "suggestions",
    staticClass: "suggestion-list"
  }, [_vm.hasResults ? _vm._l(_vm.filteredItemList, function (field, index) {
    return _c('div', {
      key: field.key,
      staticClass: "suggestion-list__item",
      class: {
        'is-selected': _vm.navigatedFieldIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectField(field);
        }
      }
    }, [_vm._v(" " + _vm._s(field.name) + " ")]);
  }) : _c('div', {
    staticClass: "suggestion-list__item is-empty"
  }, [_vm._v(" " + _vm._s(_vm.$t('no_match_found')) + " ")])], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }